import { ModalCloseButton } from '@/components/Modal';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import { getAuthModalTypeFromPath } from './AuthModalV2';
import styles from './styles/RegisterHeader.module.scss';

export default function RegisterHeader() {
  const [{ path }, { handleCloseAuthModal, handleOpenLink }] = useApplicationContainer();
  const formType = getAuthModalTypeFromPath(path);
  return (
    <div className={styles.HeaderContainer}>
      <div className={styles.HeaderTitle}>
        <div className={styles.Tagline}>What's your email?</div>
        <div className={styles.Instruction}>Enter your email address to start registration</div>
      </div>
      <ModalCloseButton
        onClose={formType ? () => handleOpenLink('/') : handleCloseAuthModal}
        className={styles.CloseButton}
        width={17}
        height={17}
      />
    </div>
  );
}
